import React, { Component } from 'react';

class OrderDetailAddress extends Component {
    render() {
        const { name, address, province, postalCode, phone } = this.props.order.address;

        return (
            <div className="address">
                <label>Address</label>
                <p>
                    <span>{name}</span>
                    <br /> {phone}
                    <br /> {address}
                    <br /> {`${province} - ${postalCode}`}
                </p>
            </div>
        );
    }
}

export default OrderDetailAddress;



// WEBPACK FOOTER //
// ./src/views/orders/OrderDetailAddress.js